import { Outlet, Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import Nav from "../components/Nav";
import '../App.css';


function MainLayout() {
  const { strings } = useLanguage();

  return (
    <div className="main">
      <Nav />
      <Outlet />
      <footer className="site-footer">
        <Link to="/terms-and-privacy" className="site-footer">{strings.terms_of_service.title}</Link>
      </footer>
    </div>
  );
}
export default MainLayout;